import { render, staticRenderFns } from "./Hindex.vue?vue&type=template&id=0056bfa3&scoped=true"
import script from "./Hindex.vue?vue&type=script&lang=js"
export * from "./Hindex.vue?vue&type=script&lang=js"
import style0 from "./Hindex.vue?vue&type=style&index=0&id=0056bfa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0056bfa3",
  null
  
)

export default component.exports